import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import NotFound from '@tracker/shared/src/NotFound';
import PreferencesProvider from '@tracker/shared/src/Preferences/PreferencesProvider';
import ProjectsProvider from '@tracker/shared/src/Projects/ProjectsProvider';
import UserMenu from '@tracker/shared/src/UserMenu/UserMenu';
import React from 'react';
import {Route, Switch} from 'react-router';
import {BrowserRouter} from 'react-router-dom';
import Home from './pages/Home/Home';

const useStyles = makeStyles(theme => ({
    title: {
        flexGrow: 1,
    },
    content: {
        padding: theme.spacing(4),
    },
}));

const Main : React.FC = () => {
    const classes = useStyles();

    return (
        <PreferencesProvider categories={['dashboard']}>
            <ProjectsProvider>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                        Dashboard
                        </Typography>
                        <UserMenu/>
                    </Toolbar>
                </AppBar>

                <Container maxWidth="lg" className={classes.content}>
                    <BrowserRouter>
                        <Switch>
                            <Route path="/" exact component={Home}/>
                            <Route path="*" component={NotFound}/>
                        </Switch>
                    </BrowserRouter>
                </Container>
            </ProjectsProvider>
        </PreferencesProvider>
    );
};

export default Main;
